import { PureComponent } from 'react';
import PropTypes from 'prop-types';

const pageViewProps = {
  content_type: '',
  navigation_section: '',
  article_type: '',
  article_subtype: '',
  article_tags: '',
  author_name: '',
  last_updated_date: '',
  last_updated_time: '',
  published_date: '',
  published_time: '',
  sponsored_article: '',
  sponsored_link: '',
  sponsored_text: '',
  make: '',
  model: '',
  product_id: '',
  category: '',
  car_type: '',
  acceleration: '',
  annual_tax: '',
  boot_capacity: '',
  car_id: '',
  co2_emissions: '',
  engine: '',
  event: 'view_page',
  fuel_consumption: '',
  fuel_type: '',
  gear_box: '',
  ham_id: '',
  manufacturer_price: '',
  no_of_doors: '',
  no_of_seats: '',
  target_price: '',
  trim: '',
  version: '',
  body_style: ''
};

export class DataLayerPush extends PureComponent<*, *> {
  static propTypes = {
    event: PropTypes.string
  };

  componentDidMount() {
    const dataLayer = window.dataLayer;
    if (dataLayer) {
      dataLayer.push({
        ...pageViewProps,
        ...this.props
      });
    }
  }

  componentDidUpdate(prevProps) {
    const dataLayer = window.dataLayer;
    // If we're on a new page, send a custom event.
    dataLayer &&
      dataLayer.push({
        ...pageViewProps,
        ...this.props
      });
  }

  componentWillUnmount() {
    const data = { ...pageViewProps, ...this.props };

    if (data && data.event) {
      delete data.event;
    }
    const dataLayer = window.dataLayer;
    if (dataLayer) {
      // Set each property to undefined.
      Object.keys(data).forEach(key => (data[key] = undefined));
      Object.keys(data).length && dataLayer.push(data);
    }
  }

  render() {
    return null;
  }
}

export default DataLayerPush;



// WEBPACK FOOTER //
// ./src/components/DataLayerPush/index.js